import { render, staticRenderFns } from "./OvertimeApproval.vue?vue&type=template&id=0970695a&"
import script from "./OvertimeApproval.vue?vue&type=script&lang=js&"
export * from "./OvertimeApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports